<ds-modal
  #campaignDetailsModal
  [dimensionsConfig]="{ width: '620px' }"
  [ds-modal-trigger-for]="campaignDetailsModal"
  [(isModalOpen)]="campaignDetailsModalIsOpen"
  [detachFooter]="true"
>
  <ds-box-header style="font-size: xx-large; font-weight: bold">
    Campaign Details
  </ds-box-header>
  <ds-box-content>
    <div style="display: flex; gap: 20px">
      <div style="flex: 1; min-width: auto">
        <img
          src="{{ campaignDetail.imageUrl }}"
          alt="Campaign Image"
          style="width: auto; height: 150px"
        />
      </div>
      <div style="flex: 2; display: flex; flex-wrap: wrap; gap: 20px">
        <div style="flex: 1; min-width: 250px">
          <span></span>
          <span
            ><b>{{ campaignDetail.modelDescription }}</b></span
          >
        </div>
        <div
          style="
            flex: 1;
            min-width: 250px;
            display: flex;
            align-items: flex-start;
          "
        >
          <span style="font-weight: bold; min-width: 160px">Campaign ID:</span>
          <span>{{ campaignDetail.campaign }}</span>
        </div>
        <div
          style="
            flex: 1;
            min-width: 250px;
            display: flex;
            align-items: flex-start;
          "
        >
          <span style="font-weight: bold; min-width: 160px">Campaign VIN:</span>
          <span>{{ campaignDetail.vin }}</span>
        </div>
        <div
          style="
            flex: 1;
            min-width: 250px;
            display: flex;
            align-items: flex-start;
          "
        >
          <span style="font-weight: bold; min-width: 160px"
            >Campaign Description:</span
          >
          <span>{{ campaignDetail.recallText }}</span>
        </div>
      </div>
    </div>
  </ds-box-content>
  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="closeModal()"
    >
      Close
    </button>
  </ds-box-footer>
</ds-modal>
